import { FC, useState } from "react";

import { BaseModal } from "@/components/BaseModal";
import { PhotoUpload } from "@/components/Modals/UploadRetryModal/components/PhotoUpload";
import { SyncRequests } from "@/components/Modals/UploadRetryModal/components/SyncRequests";
import { NetworkIndicator } from "@/components/NetworkIndicator";
import { UniversalTabs } from "@/components/UniversalTabs";

interface UploadRetryModalProps {
    onClose: () => void;
    photoCount: number;
    requestCount: number;
}

export const UploadRetryModal: FC<UploadRetryModalProps> = ({
    onClose,
    photoCount,
    requestCount,
}) => {
    const getInitialTab = () => {
        if (photoCount > 0) return "photo";
        if (requestCount > 0) return "request";
        return "photo";
    };

    const [currentTab, setCurrentTab] = useState(getInitialTab);

    return (
        <BaseModal
            open={true}
            onClose={onClose}
            actions={null}
            maskClosable={true}
            title={"Синхронізація"}
            icon={<NetworkIndicator />}
        >
            <UniversalTabs
                value={currentTab}
                onChange={setCurrentTab}
                tabs={[
                    {
                        value: "photo",
                        label: "Фото",
                        count: photoCount,
                    },
                    {
                        value: "request",
                        label: "Запити",
                        count: requestCount,
                    },
                ]}
                maxWidth="300px"
            />

            {currentTab === "photo" && <PhotoUpload />}

            {currentTab === "request" && <SyncRequests />}
        </BaseModal>
    );
};
